import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useLocationQueryParams from './useLocationQueryParams';
import { setSelectedDepot } from '../store/reducers/routePlannerApp';
import { getUserDepots } from '../store/selectors/user';
import usePrevious from './usePrevious';
import { wrapPromise } from '../utils/promise';
import { clearRouteFilters } from '../store/reducers/ui/filterPanel';

const useDepotChangeListener = (warningModalRef) => {
  const dispatch = useDispatch();
  const { depot } = useLocationQueryParams();
  const prevDepot = usePrevious(depot);
  const userDepots = useSelector(getUserDepots);

  const redirectToNewEnv = useCallback(
    (redirectUrl) => {
      window.location.href = `https://${redirectUrl}/${window.location.pathname}?depot=${depot}`;
    },
    [depot]
  );

  const showRedirectModal = useCallback(
    async (redirectUrl) => {
      await wrapPromise(warningModalRef.current.showModal());
      redirectToNewEnv(redirectUrl);
    },
    [warningModalRef, redirectToNewEnv]
  );

  useEffect(() => {
    // TODO: remove this once we have a new Oracle environment mode
    // const depotData = getDepotByCode(userDepots, depot);
    // if (
    //   process.env.NODE_ENV !== 'development' &&
    //   depotData &&
    //   depotData.operatingEnvironmentHost &&
    //   depotData.operatingEnvironmentHost !== window.location.hostname
    // ) {
    //   const redirectUrl = depotData.operatingEnvironmentHost;
    //   depotData.environmentMode === ENVIRONMENT_MODE.DISASTER_RECOVERY
    //     ? showRedirectModal(redirectUrl)
    //     : redirectToNewEnv(redirectUrl);
    // }
    if (prevDepot !== depot) {
      dispatch(setSelectedDepot(depot));
      dispatch(clearRouteFilters());
    }
  }, [
    depot,
    dispatch,
    prevDepot,
    redirectToNewEnv,
    showRedirectModal,
    userDepots,
  ]);
};

export default useDepotChangeListener;
